var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgQuestionIcon(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.047 1.95c9.258 0 17.028 7.62 17.028 17.063 0 9.442-7.605 17.062-17.028 17.062-3.307 0-6.613-.994-9.258-2.816l-6.613 2.816c-.33-.166-.496-.166-.496-.166-.166 0-.33-.165-.496-.165-.166-.166-.33-.497-.166-.829L4.83 28.29c-1.819-2.816-2.81-5.963-2.81-9.277 0-9.276 7.604-17.062 17.028-17.062zm-.166 1.325c-8.596 0-15.54 6.958-15.54 15.572 0 3.147.992 6.295 2.81 8.945.166.166.166.497.166.663L4.002 33.92l5.456-2.319c0-.165.165-.165.165-.165.166 0 .331 0 .331.165 2.645 1.823 5.621 2.816 8.927 2.816 8.597 0 15.54-6.957 15.54-15.571S27.479 3.275 18.882 3.275zm.496 23.192c.166.166.166.331.166.497 0 .166-.166.331-.166.497-.165.166-.33.331-.496.331-.165 0-.33-.165-.496-.331-.147 0-.163-.262-.165-.436v-.061c0-.166 0-.331.165-.497.331-.331.662-.331.992 0zm-.33-16.4c2.81 0 5.125 2.32 5.125 5.135 0 2.485-1.819 4.639-4.299 4.97v3.148c-.33.33-.66.662-.992.662-.33 0-.66-.331-.66-.662v-3.81c0-.332.33-.663.66-.663 1.984 0 3.638-1.657 3.638-3.645 0-1.987-1.654-3.644-3.638-3.644-1.983 0-3.637 1.657-3.637 3.644 0 .332-.33.663-.661.663-.33 0-.661-.331-.661-.663 0-2.816 2.314-5.135 5.125-5.135z",
    fill: `url(#${_id})`,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "7.565%",
    x2: "22.6%",
    y2: "87.141%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  })))));
}
export default SvgQuestionIcon;